class PopularPicks {
  constructor() {
    this.container = document.querySelectorAll('.pc-Subcategories-section-container.products')[1];
    this.pills = document.querySelectorAll('.pc-Subcategories-section-nav-item.products');
    this.cards = document.querySelectorAll('.pc-Subcategories-section-product-card');
    this.initializePills();
  }

  // Private

  initializePills() {
    this.pills.forEach(elem => {
      elem.onclick = () => {
        this.pills.forEach(pill => pill.classList.remove('is-active'));
        elem.classList.add('is-active');
        this.cards.forEach(card => {
          if (card.getAttribute('data-cat-id') === elem.getAttribute('data-cat-id') ||
            card.getAttribute(`data-color-id-${elem.getAttribute('data-cat-id')}`) 
          ) {
            if (card.classList.contains('product-find') === false) {
              const imgElem = card.querySelector('.pc-Subcategories-section-product-card-image img');
              const colorId = card.getAttribute(`data-color-id-${elem.getAttribute('data-cat-id')}`);
              imgElem.src = imgElem.src.replace(/(\/\d+\/)/g, `/${colorId}/`);
              imgElem.srcset = imgElem.srcset.replace(/(\/\d+\/)/g, `/${colorId}/`);
            }
            card.style.display = 'inline-flex';
          } else {
            card.style.display = 'none';
          }
        });
        ProductCatalog.Tooltip.closeAll();
        this.container.scrollTo({ left: 0, behavior: 'smooth' });
      };
    });
  }
}

jQuery(() => (ProductCatalog.PopularPicks = new PopularPicks()));
